import React from "react";

const TERMS = [
  "TRADE DOCS", "STATE COMPLIANCE", "LICENSE RENEWALS", "PERMITS",
  "INSURANCE", "SURETY BONDS", "DEADLINE TRACKING", "TAX FORMS",
  "AI AGENT", "PAPERWORK, HANDLED",
];

export default function Marquee() {
  const items = [...TERMS, ...TERMS];
  return (
    <div className="relative py-10 border-y border-white/10 bg-surface/40 marquee-mask overflow-hidden">
      <div className="marquee-track">
        {items.map((t, i) => (
          <div key={i} className="flex items-center shrink-0">
            <span className="px-8 font-display font-bold text-2xl sm:text-3xl tracking-tight text-white/25 whitespace-nowrap">
              {t}
            </span>
            <span className="h-2 w-2 rounded-full bg-dox-orange/70 shadow-[0_0_12px_rgba(30,120,255,0.8)]" />
          </div>
        ))}
      </div>
    </div>
  );
}
